var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWoman(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21.23,
    viewBox: "0 0 21 21.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "woman",
    transform: "translate(-5 -5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(5 5)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M29.128,26.123l-.786-3.468a5.268,5.268,0,0,0-4.423-4.875h-.083a5.268,5.268,0,0,0-4.423,4.875l-.786,3.468a.814.814,0,0,0,.881.995l4.364-.448,4.38.452a.814.814,0,0,0,.877-1Z",
    transform: "translate(-8.256 -7.755)",
    fill: "#262234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M28.421,47.6a10.592,10.592,0,0,1-13.171,0l.295-1.046A3.578,3.578,0,0,1,18.3,44.075,3.251,3.251,0,0,1,19,44H24.67a3.251,3.251,0,0,1,.708.075,3.578,3.578,0,0,1,2.748,2.481Z",
    transform: "translate(-6.22 -23.667)",
    fill: "#5a143c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M31.145,39.37v3.169l-1.573.786L28,42.538V39.37a.37.37,0,0,1,.37-.37h2.4a.37.37,0,0,1,.373.37Z",
    transform: "translate(-13.957 -20.633)",
    fill: "#ffd2b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M24.117,15.21c4.325,0,3.971,4.242,3.971,4.242.637-.067,1.14.193,1.14,1.124s-.393,1.124-.889,1.179a.11.11,0,0,0-.1.106,4.724,4.724,0,0,1-2.115,3.224,3.377,3.377,0,0,1-4.006,0A4.733,4.733,0,0,1,20,21.862a.11.11,0,0,0-.1-.106c-.5-.051-.889-.248-.889-1.179s.48-1.179,1.117-1.124C20.123,19.452,19.769,15.21,24.117,15.21Z",
    transform: "translate(-8.502 -6.196)",
    fill: "#ffd2b4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 0.668,
    cy: 0.668,
    r: 0.668,
    transform: "translate(13.39 13.433)",
    fill: "#262234"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 0.668,
    cy: 0.668,
    r: 0.668,
    transform: "translate(16.504 13.433)",
    fill: "#262234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M30.583,32.53a.393.393,0,0,1,.393.491,1.966,1.966,0,0,1-3.806,0,.393.393,0,0,1,.393-.491Z",
    transform: "translate(-13.447 -16.706)",
    fill: "#611c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M31.483,35.957a1.966,1.966,0,0,1-1.9,0c.079-.484.476-.617.951-.617S31.4,35.474,31.483,35.957Z",
    transform: "translate(-14.916 -18.412)",
    fill: "#be1e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M31.4,32.53V32.9a.145.145,0,0,1-.142.145H29.292a.145.145,0,0,1-.142-.145V32.53Z",
    transform: "translate(-14.655 -16.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M30.5,44A2.776,2.776,0,0,1,25,44Z",
    transform: "translate(-12.137 -23.667)",
    fill: "#ffd2b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M29.379,44H29.3a2.776,2.776,0,0,1-5.5,0h-.075a3.251,3.251,0,0,0-.708.075h0a3.562,3.562,0,0,0,7.077,0h0A3.251,3.251,0,0,0,29.379,44Z",
    transform: "translate(-10.929 -23.667)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M31.145,41v.786a3.342,3.342,0,0,1-3.145,0V41a3.342,3.342,0,0,0,3.145,0Z",
    transform: "translate(-13.957 -21.846)",
    fill: "#262234",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M29.491,16.617C29.295,13.92,26.885,13,24.97,13s-4.325.92-4.521,3.617a4.45,4.45,0,0,0,.039,1.345,12.421,12.421,0,0,0,.157,1.431c.071.307.421.295.468.02a10.639,10.639,0,0,1,.393-1.875,8.192,8.192,0,0,0,4.4-1.439,8.453,8.453,0,0,0,2.614,1.5,10.729,10.729,0,0,1,.358,1.812c.043.275.393.287.468-.02a12.1,12.1,0,0,0,.134-1.4A4.415,4.415,0,0,0,29.491,16.617Z",
    transform: "translate(-9.355 -4.855)",
    fill: "#262234"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoman);
export default __webpack_public_path__ + "static/media/woman.f8f978a2c7fafb6dc7aa24b60863777c.svg";
export { ForwardRef as ReactComponent };